const newsPath = '/articles';
export type StatusValue = 'published' | 'unpublished' | 'all';
export const getArticles = newsPath;
export const getArticleById = (id: number, type: 'news' | 'announcement' , isNullable: boolean = false ) => 
      `${newsPath}/${id}?type=${type}&isNullable=${isNullable}`;
export const createArticle = newsPath;
export const updateArticle = (id: number) => `${newsPath}/${id}`;
export const updateArticleStatus = (id: number) => `${newsPath}/${id}/publishing`;
export const filterArticles = newsPath;
export const uodateArticleDynamicLinkById = (id: number) => `${newsPath}/${id}/dynamic-link`;

// Firebase nodes
export const articlesDeepLink = 'articles';
export const articleDeepLink = (id: string | number) => `${articlesDeepLink}/${id}`;
export const articleDeepLinkQueryUrl = (id: string | number) => `redirect=articleDetails&entityId=${id}`;